
const digest = '31c9bc3b5d4cb84d7d693e0f0edd0391798b42847d5438418d535067eda278fd';
const classes = {"wrapper":"_wrapper_ftbpw_1"};
const css = `._wrapper_ftbpw_1 {
  display: flex;
  flex-direction: column;
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  